/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./zrc/scripts/collection.js":
/*!***********************************!*\
  !*** ./zrc/scripts/collection.js ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _templates_collection__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./templates/collection */ "./zrc/scripts/templates/collection.js");
/* harmony import */ var _templates_collection__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_templates_collection__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _general_filters__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./general/filters */ "./zrc/scripts/general/filters.js");
/* harmony import */ var _general_filters__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_general_filters__WEBPACK_IMPORTED_MODULE_1__);



/***/ }),

/***/ "./zrc/scripts/general/filters.js":
/*!****************************************!*\
  !*** ./zrc/scripts/general/filters.js ***!
  \****************************************/
/***/ (() => {

/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */

var filters = function () {
  return {
    checkFilters: function () {
      // if (window.boostPFS) {
      //   const filtersSize =
      //     window.boostPFS.filter.filterTrees[0].filterOptions.size;

      //   window.console.log('¿Qué es esto?: ' + filtersSize);

      //   if (
      //     filtersSize < 1 &&
      //     !$('.boost-pfs-search-panel-product-show.sort').length
      //   ) {
      //     $('.boost-pfs-filter-wrapper').addClass('one-column');
      //   } else {
      //     $('.boost-pfs-filter-wrapper').removeClass('one-column');
      //   }

      //   $('.boost-pfs-filter-wrapper').removeClass('hidden');
      // }

      // window.console.log(`¿QUÉ ES ESTO?: ${JSON.stringify(window.boostPFS)}`)

      if (!$('.boost-pfs-filter-option').length) {
        $('.boost-pfs-filter-wrapper').addClass('one-column');
        $('.boost-pfs-filter-tree-mobile-button').hide();
      } else {
        $('.boost-pfs-filter-wrapper').removeClass('one-column');
      }
      $(document).on('click', '.boost-pfs-filter-option-item .boost-pfs-filter-button', () => {
        window.scrollTo({
          behavior: 'smooth',
          top: 0
        });
      });
    }
  };
}();
$(window).load(() => {
  if ($('body').hasClass('template-collection') || $('body').hasClass('template-search')) {
    filters.checkFilters();
  }
});

/***/ }),

/***/ "./zrc/scripts/templates/collection.js":
/*!*********************************************!*\
  !*** ./zrc/scripts/templates/collection.js ***!
  \*********************************************/
/***/ (() => {

class Collection extends window.HTMLElement {
  constructor() {
    super();
    this.container = this;
    this.whenOnlyGridItem();
    this.stickyFilters();
    this.templateDescriptions();
    this.checkIfExistImage();
    this.titleLastWord();
    this.scrollToTop();
    this.configHeightsTexts();
  }
  whenOnlyGridItem() {
    $(window).on('load', () => {
      var gridElements = document.querySelector('.collection-grid').childElementCount;
      if (gridElements === 1) {
        document.querySelector('.boost-pfs-filter-wrapper').classList.add('one-column');
        document.querySelector('.boost-pfs-filter-tree-mobile-button').style.display = "none";
      }

      // window.console.log(`¿QUÉ ES ESTO, SAMUS?: ${samus}`);
    });
  }
  stickyFilters() {
    function filtersTop() {
      var filtersContent = document.querySelector('.collection-filters-content');
      var headerHeight = document.querySelector('.header-section-wrapper').offsetHeight + 20;
      filtersContent.style.top = "".concat(headerHeight, "px");
    }
    window.setInterval(() => {
      filtersTop();
    }, 300);
  }
  templateDescriptions() {
    var util = {
      cleanString(str) {
        var newString = str.toLowerCase().replace('á', 'a').replace('é', 'e').replace('í', 'i').replace('ó', 'o').replace('ú', 'u').replace('ñ', 'n').replace(new RegExp(' ', 'g'), '-');
        return newString;
      }
    };
    var parent = $('#collection-description');
    var titles = parent.find('h6');
    titles.each((index, el) => {
      var title = $(el).text();
      var content = $(el).nextUntil('h6');
      var data = util.cleanString(title);
      $("[data-".concat(data, "]")).append(content);
    });
  }
  checkIfExistImage() {
    $('.collection-cover-image-mobile').each(function () {
      if ($(this).find('img').length) {
        $(this).addClass('with-image');
      }
    });
  }
  titleLastWord() {
    $('.collection-cover-title').html(function () {
      // separate the text by spaces
      var text = $(this).text().split(' ');
      // drop the last word and store it in a variable
      var last = text.pop();
      // join the text back and if it has more than 1 word add the span tag
      // to the last word
      return text.join(" ") + (text.length >= 0 ? " <span class=\"last-title-word\">".concat(last, "</span>") : last);
    });
    $('.boost-pfs-filter-collection-header.collection-title').html(function () {
      // separate the text by spaces
      var text = $(this).text().split(' ');
      // drop the last word and store it in a variable
      var last = text.pop();
      // join the text back and if it has more than 1 word add the span tag
      // to the last word
      return text.join(" ") + (text.length >= 0 ? " <span class=\"last-title-word-black\">".concat(last, "</span>") : last);
    });
  }
  scrollToTop() {
    $(document).on('click', '.pagination-arrow', () => {
      window.setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }, 700);
    });
  }
  configHeightsTexts() {
    var productCardTitles = this.container.querySelectorAll('.product-card-title');
    var gridOptions = [{
      breakpoint: 1440,
      columns: 3
    }, {
      breakpoint: 980,
      columns: 2
    }];
    window.setHeightCardTexts(productCardTitles, '--product-card-title-height', gridOptions);
  }
}
if (window.customElements.get('collection-section') == null) {
  window.customElements.define('collection-section', Collection);
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	// startup
/******/ 	// Load entry module
/******/ 	__webpack_require__("./zrc/scripts/collection.js");
/******/ 	// This entry module used 'exports' so it can't be inlined
/******/ })()
;